export default {
  black: "#233044",
  white: "#F6F6F6",
  grey: "#8A8989",
  primary: "#03C9A9",
  blue: "#0966ba",
  paleBlue: "#4299e8",
  fadedBlack: "rgba(0, 0, 0, 0.3)",
  R: "#FF211B",
  G: "#17E620",
  B: "#003AEC",
  raw: {
    R: "#FF0000",
    G: "#00FF00",
    B: "#0000FF",
  },
};
